import { WorkflowDesktopView } from './WorkflowDesktopView';

export function WorkflowTabletView() {
  return <WorkflowDesktopView mode="tablet" />;
}
